import React, { Component } from "react";

import InputMask from "react-input-mask"

class CadastroPaciente extends Component {
  render() {
    let styleContraste = {
      border: "1px dashed #777",
      fontWeight: "700",
      background: "#fff"
    }

    return (
      <div className="row">
        <div className="col-12 grid-margin">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">PACIENTE</h4>
              <div className="form-group row">
                <div className="col-md-3">
                  <label>ID Cismepar</label>
                  <input
                    style={styleContraste}
                    disabled
                    placeholder="NÃO INFORMADO"
                    name="idCismepar"
                    className="form-control"
                    value={this.props.paciente.idCismepar}
                  />
                </div>
                <div className="col-md-3">
                  <label>CPF</label>
                  <InputMask
                    style={styleContraste}
                    disabled
                    placeholder="NÃO INFORMADO"
                    name="cpf"
                    className="form-control"
                    mask="999.999.999-99"
                    value={this.props.paciente.cpf}
                  />
                </div>
                <div className="col-md-6">
                  <label>Nome</label>
                  <input
                    style={styleContraste}
                    disabled
                    placeholder="NÃO INFORMADO"
                    name="nome"
                    className="form-control"
                    value={this.props.paciente.nome}
                  />
                </div>
              </div>
              <div className="form-group row">
                <div className="col-md-3">
                  <label>Estado (Origem)</label>
                  <input
                    style={styleContraste}
                    disabled
                    placeholder="NÃO INFORMADO"
                    name="estado"
                    className="form-control"
                    value={this.props.paciente.endereco.estado}
                  />
                </div>
                <div className="col-md-3">
                  <label>Cidade (Origem)</label>
                  <input
                    style={styleContraste}
                    disabled
                    placeholder="NÃO INFORMADO"
                    name="cidade"
                    className="form-control"
                    value={this.props.paciente.endereco.cidade}
                  />
                </div>
                <div className="col-md-3">
                  <label>Data Nascimento</label>
                  <InputMask
                    style={styleContraste}
                    disabled
                    type="text"
                    placeholder="NÃO INFORMADO"
                    name="dataNascimento"
                    className="form-control"
                    mask="99/99/9999"
                    value={this.props.paciente.dataNascimento}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CadastroPaciente;
